<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                v-model="date"
                :label="label"
                :errorMessages="errorMessages"
                prepend-icon="mdi-calendar-month"
                readonly
                v-on="on"
            ></v-text-field>
        </template>

        <v-date-picker
            v-model="date"
            first-day-of-week="1"
            locale="sk"
            no-title
            scrollable
            v-bind="$attrs"
        >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">Zrušiť</v-btn>
            <v-btn text color="primary" @click="dateSelected(date)">Potvrdiť</v-btn>
        </v-date-picker>
    </v-menu>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    errorMessages: [ String, Array ]
  },

  data () {
    return {
      date: '',
      menu: false
    }
  },

  watch: {
    value: {
      immediate: true,
      handler (to) {
        this.date = to
      }
    }
  },

  methods: {
    dateSelected (date) {
      this.$refs.menu.save(date)
      this.$emit('input', date)
    }
  }
})
</script>
